import register from 'ShopUiBundle/modules/app/registry';

import 'ShopUiBundle/components/molecules/basic-modal';
import 'SprykerProductBundle/components/atoms/select-size-link';
import './style.scss';

// tslint:disable-next-line
register('bike-detail-select-size-modal', () => import(/* webpackMode: "lazy" */'./bike-detail-select-size-modal'));
